export default "__VITE_ASSET__CAGBP1H7__"